import { ProfileStatus } from "@edp-models/profile-status.model";
import { UserLevelStatus } from "@edp-models/user-level.model";
import { UserNotification } from "@edp-models/user-notification.model";
import { EdpUser } from "@edp-models/user.model";
import { Action } from "@ngrx/store";

export enum EUserActions {
    SetUser = "Set User",
    SetOnBoarding = "Set OnBoarding",
    SetLevelStatus = "[User] Set user level status",
    APIError = "[UserNotification] API error",
    UserNotificationsGetAll = "[UserNotification] Get All",
    UserNotificationsSetList = "[UserNotification] Set List",
    MarkNotificationReaded = "[UserNotification] Mark as Readed",
    MarkNotificationReadedPersist = "[UserNotification] Mark as Readed Persist",
    SetTotalNotificationUnreaded = "[UserNotification] Set Total Unreaded",
    MarkNotificationViewed = "[UserNotification] Mark as Viewed",
    MarkNotificationViewedPersist = "[UserNotification] Mark as Viewed Persist",
    UserWelcomeViewed = "[User] Welcome Page Viewed",
    UserEdpESubscribed = "[User] Subscription Page",
    UserEdpESubViewed = "[User] Subscription Page Viewed",
    IsUserEdpE = "[User] With EdpE",
    MarkLevelModalAsRead = "[User] Mark level modal as read",
    UserNotificationsSetTotalNotViewed = "[UserNotification] Set Total NotViewed",
    MarkPlanetAnniversaryAsRead = "[User] Mark Planet Anniversary as read",
    SetPlanetAnniversary = "[User] Set Planet Anniversary as read",
    GetPlanetAnniversary = "[User] Get Planet Anniversary",
    MarkVideoOnboardingAsViewed = "[User] Mark video onboarding as viewed",
    SetCebrationZs = "[User] Set Cebration Zs",
    GetCounter = "[User] Get Counter",
    SetViewToastLocalReception = "[User] Set view Toast Local Reception",
    GetProfileStatus = "[User] Get Profile Status",
    SetProfileStatus = "[User] Set Profile Status",
    SetTermsCond = "[User] Set Terms Conditions"
}

export class SetUser implements Action {
    public readonly type = EUserActions.SetUser;
    constructor(public user: EdpUser) {}
}
export class SetOnBoarding implements Action {
    public readonly type = EUserActions.SetOnBoarding;
    constructor(public onboarding: boolean) {}
}

export class SetLevelStatus implements Action {
    public readonly type = EUserActions.SetLevelStatus;
    constructor(public levelStatus: UserLevelStatus) {}
}

export class UserNotificationsAPIError implements Action {
    public readonly type = EUserActions.APIError;
    constructor(public error: Error) {}
}

export class UserNotificationsGetAll implements Action {
    public readonly type = EUserActions.UserNotificationsGetAll;
    }

export class UserNotificationsSetList implements Action {
    public readonly type = EUserActions.UserNotificationsSetList;
    constructor(public payload: UserNotification[]) {}
}

export class UserNotificationsSetTotalNotViewed implements Action {
    public readonly type = EUserActions.UserNotificationsSetTotalNotViewed;
    }

export class UserNotificationsMarkReaded implements Action {
    public readonly type = EUserActions.MarkNotificationReaded;
    constructor(public payload: UserNotification) {}
}

export class UserNotificationsMarkReadedPersist implements Action {
    public readonly type = EUserActions.MarkNotificationReadedPersist;
    constructor(public payload: UserNotification) {}
}

export class UserNotificationsMarkViewed implements Action {
    public readonly type = EUserActions.MarkNotificationViewed;
    }

export class UserNotificationsMarkViewedPersist implements Action {
    public readonly type = EUserActions.MarkNotificationViewedPersist;
    }

export class UserWelcomeViewed implements Action {
    public readonly type = EUserActions.UserWelcomeViewed;
    }

export class UserEdpESubscribed implements Action {
    public readonly type = EUserActions.UserEdpESubscribed;
    constructor(public code: string) {}
    }

export class UserEdpESubViewed implements Action {
    public readonly type = EUserActions.UserEdpESubViewed;
    }

export class IsUserEdpE implements Action {
    public readonly type = EUserActions.IsUserEdpE;
    constructor(public payload: boolean) {}
}

export class MarkLevelModalAsRead implements Action {
    public readonly type = EUserActions.MarkLevelModalAsRead;
}

export class MarkPlanetAnniversaryAsRead implements Action {
    public readonly type = EUserActions.MarkPlanetAnniversaryAsRead;
    constructor() {}
}

export class SetPlanetAnniversary implements Action {
    public readonly type = EUserActions.SetPlanetAnniversary;
    constructor(public payload: number) {}
}

export class GetPlanetAnniversary implements Action {
    public readonly type = EUserActions.GetPlanetAnniversary;
}

export class MarkVideoOnboardingAsViewed implements Action {
    public readonly type = EUserActions.MarkVideoOnboardingAsViewed;
}

export class GetCounter implements Action {
    public readonly type = EUserActions.GetCounter;
}

export class SetCebrationZs implements Action {
    public readonly type = EUserActions.SetCebrationZs;
    constructor(public payload: number) {}
}

export class SetViewToastLocalReception implements Action {
    public readonly type = EUserActions.SetViewToastLocalReception;
    constructor(public payload: number) {}
}

export class GetProfileStatus implements Action {
    public readonly type = EUserActions.GetProfileStatus;
}

export class SetProfileStatus implements Action {
    public readonly type = EUserActions.SetProfileStatus;
    constructor(public payload: ProfileStatus) {}
}
export class SetTermsCond implements Action {
    public readonly type = EUserActions.SetTermsCond;
}

export type UserActions =
    | SetUser
    | SetLevelStatus
    | UserNotificationsGetAll
    | UserNotificationsSetList
    | UserNotificationsMarkReaded
    | UserNotificationsMarkReadedPersist
    | UserNotificationsMarkViewed
    | UserNotificationsMarkViewedPersist
    | UserNotificationsAPIError
    | UserNotificationsSetTotalNotViewed
    | UserWelcomeViewed
    | UserEdpESubscribed
    | UserEdpESubViewed
    | SetOnBoarding
    | IsUserEdpE
    | MarkLevelModalAsRead
    | MarkPlanetAnniversaryAsRead
    | SetPlanetAnniversary
    | GetPlanetAnniversary
    | MarkVideoOnboardingAsViewed
    | GetCounter
    | SetCebrationZs
    | GetProfileStatus
    | SetProfileStatus
    | SetTermsCond;
